import intl from "react-intl-universal";
import axios from 'axios';
// import queryParser from 'query-string';
import store from '../store';
import common from '../common/common';
import hosts from "./hosts";

const axiosX = axios.create({
  baseURL: hosts.apiUrl,
  timeout: 80000,
});


axiosX.interceptors.request.use(function (config) {
  config.headers.token = store.getState().token || common.getSearchParam()?.token || '';
  // axios会根据传入的data不同类型自动对应设置headers的Content-Type成以下形式'application/json; charset=UTF-8' 'application/x-www-form-urlencoded' 'multipart/form-data'
  return config;
})
// axiosX.defaults.headers.common['token'] = '34242342343';
axiosX.interceptors.response.use(function (response) {
  if (response.status === 200 || response.status === 304) {
    return Promise.resolve(response.data);
  } else {
    toast('statusError:' + response.status);
    return Promise.reject(response);
  }
}, function (err) {
  console.log(err.response, 94);
  if (err && err.response) {
    toast('statusError:' + err.response.status);
  } else {
    toast(intl.get('NETWORK_ERROR'));
  }
  return Promise.reject(err);
});


/**
 * get请求
 * @method get
 * @param {url, params} 请求地址，请求参数
 */
const get = (url, params) => {
  return new Promise((resolve, reject) => {
    let tokenStr = window.location.search ? window.location.search : '';
    axiosX
      .get(`${url}`, { params })
      .then(res => {
        if (res.code === 20012) {
          var tokenInfoStr = JSON.stringify({
            errID: res.code,
            errMsg: res.msg
          });
          sendClient('onWebError', tokenInfoStr);
          reject(res);
        } else if (url.includes('/api/schedule/get-classroom') || url.includes('/api/login/fetchToken/')) {
          res.code === 0 && resolve(res.data);
        } else if (res.code === 200) {
          resolve(res.data);
        } else if (res.code === 21012) {
          toast(res.msg);
          login();
          console.log('21012get')
          return;
          // reject(res);
        } else {
          res.msg && toast(res.msg);
          // toast('errCode' + res.code);
          reject(res);
        }

      })
      .catch(err => {
        // final axios return => err
        reject(err);
      });
  });
};

/**
 * post请求
 * @method post
 * @param {url, data} 请求地址，请求参数
 */
const post = (url, data, config) => {
  return new Promise((resolve, reject) => {
    let tokenStr = window.location.search ? window.location.search : '';
    // 如果服务端固定要求x-www-form-urlencoded，，，，直接设置data = qs.stringify(data)调用时post(url,{a:1,b:2})即可
    axiosX
      .post(`${url}`, data, config)
      .then(res => {
        if (res.code === 20012) {
          var tokenInfoStr = JSON.stringify({
            errID: res.code,
            errMsg: res.msg
          });
          sendClient('onWebError', tokenInfoStr);
          reject(res);
        } else if (res.code === 200) {
          resolve(res.data);
        } else if (res.code ===21012){
          toast(res.msg);
          console.log('21012post');
          login();
          return;
          // reject(res);
        }else {
          // toast(JSON.stringify(res))
          toast(res.msg);
          // toast('errCode' + res.code);
          reject(res);
        }
      })
      .catch(err => {
        // final axios return  err
        reject(err);
      });
  });
};

const sendClient = (agreement, jsonStr) => {
  if (navigator.userAgent.indexOf('Android') > -1 || navigator.userAgent.indexOf('Adr') > -1) {
    window.android && window.android[agreement](jsonStr);
  } else if (window.Sac_jsCallC) {
    window.Sac_jsCallC(agreement, jsonStr);
  } else {
      let obj = {};
      obj[agreement] = jsonStr;
      window.webkit.messageHandlers['Sac_jsCallC'].postMessage(obj);
  }
  // if (navigator.userAgent.indexOf("Window") > 0 || navigator.userAgent.indexOf("Name/xdf-browser") > 0) {
  //   window.Sac_jsCallC(agreement, jsonStr);
  //   return;
  // }
  // if (navigator.userAgent.indexOf("Window") > 0) {
  //   window.Sac_jsCallC && window.Sac_jsCallC(agreement, jsonStr);
  // }
  // if (navigator.userAgent.indexOf("Mac OS X") > 0) {
  //   var obj = {};
  //   obj[agreement] = jsonStr;
  //   window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers['Sac_jsCallC'].postMessage(obj);
  // }

}

const login = () => {
  const host = window.location.host;
  let urlHost = ''
  if (host.includes('testd')) {
    urlHost = 'testuc.roombox.xdf.cn';
  } else if (process.env.ORG === 'meike') {
    urlHost = 'uc.mk.metcom.com.cn';
  } else {
    urlHost = 'uc.roombox.xdf.cn';
  }
  const orgId = common.getSearchParam()?.orgId
  let loginUrl = `https://${urlHost}/user/authCenter?pure=1&auth=1&language=cn&organizationId=${orgId}&from=${window.location.href}`;
  setTimeout(() => {
    window.location.href = loginUrl;
  }, 1000);
  return;
}

const setupWebViewJavascriptBridge = (callback) => {
  var bridge = window.WebViewJavascriptBridge || window.WKWebViewJavascriptBridge;
  if (bridge) { return callback(bridge); }
  var callbacks = window.WVJBCallbacks || window.WKWVJBCallbacks;
  if (callbacks) { return callbacks.push(callback); }
  window.WVJBCallbacks = window.WKWVJBCallbacks = [callback];
  if (window.WKWebViewJavascriptBridge) {
    window.webkit.messageHandlers.iOS_Native_InjectJavascript.postMessage(null);
  } else {
    var WVJBIframe = document.createElement('iframe');
    WVJBIframe.style.display = 'none';
    WVJBIframe.src = 'https://__bridge_loaded__';
    document.documentElement.appendChild(WVJBIframe);
    setTimeout(function () { document.documentElement.removeChild(WVJBIframe) }, 0);
  }
}

const AppTransferJS = (mesType, recieveCb) => {
  setupWebViewJavascriptBridge((bridge) => {
    bridge.registerHandler(mesType, function (data, responseCallback) {
      console.log('Java called testJavascriptHandler with', data);
      recieveCb && typeof recieveCb === 'function' && recieveCb(data);
      responseCallback('公共打印还回给app, 收到数据: ' + JSON.stringify(data));
    })
  })
}

const sendMesToApp = (mesType, data, resCallBack) => {
  setupWebViewJavascriptBridge((bridge) => {
    bridge.callHandler(mesType, data, function (response) {
      console.log('公共打印App response to JS 的data:', response);
      resCallBack && typeof resCallBack === 'function' && resCallBack(response);
    })
  })
}

const toast = (msg, delay) => {
  let d = +new Date();
  let $body = document.querySelector('body');
  let content = document.createElement('div');
  content.setAttribute('id', d);
  content.classList.add('toast');
  content.style.zIndex = (d + '').slice(0, 7);
  content.innerHTML = ' <div class="toastWrap">' +
    ' <div class="toastInner">' +
    '   <div class="img"></div>' +
    '   <p>' + msg + '</p>' +
    '</div>' +
    ' </div>';
  $body.appendChild(content);
  let $d = document.getElementById(d);
  let $dp = $d.querySelector('p');
  let $toastInner = $d.querySelector('.toastInner');
  setTimeout(() => {
    let $dpHeight = parseInt(getComputedStyle($dp).height);
    $toastInner.style.borderRadius = $dpHeight / 2 + 'px';
    setTimeout(function () {
      $body.removeChild($d);
    }, delay || 3000);
  }, 0)
}
const Commun = { get, post, sendClient, AppTransferJS, sendMesToApp };
export { Commun, toast };
